/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Violation severity levels */
export enum ViolationSeverity {
  Low,
  Medium,
  High,
  Critical,
}

export type ViolationSeverityArgs = ViolationSeverity;

export function getViolationSeverityEncoder(): FixedSizeEncoder<ViolationSeverityArgs> {
  return getEnumEncoder(ViolationSeverity);
}

export function getViolationSeverityDecoder(): FixedSizeDecoder<ViolationSeverity> {
  return getEnumDecoder(ViolationSeverity);
}

export function getViolationSeverityCodec(): FixedSizeCodec<
  ViolationSeverityArgs,
  ViolationSeverity
> {
  return combineCodec(
    getViolationSeverityEncoder(),
    getViolationSeverityDecoder(),
  );
}
